import PropTypes from 'prop-types';
import React from 'react';
import MaskedText from 'react-text-mask';
import { components } from '@glowforge/ui-common';

const { FormField } = components;

const PhoneNumber = (props) => {
  const { input, meta, infoText, ...otherProps } = props; // eslint-disable-line no-unused-vars
  return (
    <FormField {...props}>
      <MaskedText
        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
        guide={false}
        type='text'
        {...otherProps}
        {...input} />
    </FormField>
  );
};

PhoneNumber.propTypes = {
  placeholder: PropTypes.string,
  infoText: PropTypes.string,
  input: PropTypes.object, // eslint-disable-line
  meta: PropTypes.object, // eslint-disable-line
};

PhoneNumber.defaultProps = {
  placeholder: null,
  infoText: null,
};

export default PhoneNumber;



// WEBPACK FOOTER //
// ./app/common/components/forms/phone-number.jsx